/**
 * Holds the Web Lock `ccphone-active` for the page lifetime: Edge's documented sleeping-tab
 * exemption. Released automatically when the page goes away; `release()` for tests/stop.
 */
export const ACTIVE_LOCK = 'ccphone-active';

export interface LockManagerLike {
  request(name: string, cb: () => Promise<void>): Promise<void>;
}

export interface HeldLock {
  readonly held: boolean;
  release(): void;
}

export function holdWebLock(name: string = ACTIVE_LOCK, locks: LockManagerLike | undefined = navigator.locks): HeldLock {
  let release: () => void = () => undefined;
  let held = false;
  if (!locks || typeof locks.request !== 'function') {
    return { get held() { return false; }, release };
  }
  const done = new Promise<void>((resolve) => {
    release = () => {
      held = false;
      resolve();
    };
  });
  locks
    .request(name, () => {
      held = true;
      return done;
    })
    .catch(() => {
      held = false;
    });
  return {
    get held() {
      return held;
    },
    release: () => release(),
  };
}
